import * as React from "react";
import "./SharedScreenSurface.component.css";
import { ModalBackdrop } from "../../../components/modal-backdrop/ModalBackdrop.component";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParticipantsStore } from "../../../store/participants.store";
import { useRemoteVideoStreamsStore } from "../../../store/remote-video-streams.store";
import { inputService } from "../../../../modules/inputs/input/InputService";
import { useTranslation } from "react-i18next";
export function SharedScreenSurface() {
    var _a;
    const [fullscreen, setFullscreen] = useState(false);
    const videoContainer = useRef(null);
    const videoElement = useRef(null);
    const [sharingUserName, setSharingUserName] = useState("");
    const remoteVideoStreams = useRemoteVideoStreamsStore();
    const users = useParticipantsStore((state) => state.allUsers);
    const { t } = useTranslation();
    const userScreenStreams = remoteVideoStreams.remoteScreenStreams.filter((s) => { var _a; return s.clientId === ((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.clientId); });
    const allUserStreams = [
        ...userScreenStreams,
        ...remoteVideoStreams.remoteCameraStreams.filter((s) => { var _a; return s.clientId === ((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.clientId); })
    ];
    const selectPreviousStream = () => {
        if (!remoteVideoStreams.openedScreenStream || allUserStreams.length <= 1)
            return;
        const index = allUserStreams.findIndex((s) => s.stream === remoteVideoStreams.openedScreenStream.stream);
        if (index < 0)
            return;
        const newStream = index === 0 ? allUserStreams[allUserStreams.length - 1] : allUserStreams[index - 1];
        remoteVideoStreams.setOpenedScreenStream(newStream);
    };
    const selectNextStream = () => {
        if (!remoteVideoStreams.openedScreenStream || allUserStreams.length <= 1)
            return;
        const index = allUserStreams.findIndex((s) => s.stream === remoteVideoStreams.openedScreenStream.stream);
        if (index < 0)
            return;
        const newStream = index === allUserStreams.length - 1 ? allUserStreams[0] : allUserStreams[index + 1];
        remoteVideoStreams.setOpenedScreenStream(newStream);
    };
    useEffect(() => {
        inputService.registerAction("removeFullscreen", closeStream, t("common:key-description-key-esc", "Close video stream")).addKey("Escape");
    }, []);
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (document.fullscreenElement === null) {
                setFullscreen(false);
            }
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);
    useEffect(() => {
        if (videoContainer.current !== null && fullscreen && remoteVideoStreams.openedScreenStream !== undefined) {
            void videoContainer.current.requestFullscreen();
        }
        else if (document.fullscreenElement !== null) {
            void document.exitFullscreen();
            setFullscreen(false);
        }
    }, [fullscreen, remoteVideoStreams.openedScreenStream]);
    useEffect(() => {
        var _a, _b, _c, _d;
        setSharingUserName((_b = (_a = users.find((u) => { var _a; return u.clientId === ((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.clientId); })) === null || _a === void 0 ? void 0 : _a.customUsername) !== null && _b !== void 0 ? _b : "");
        if (videoElement.current) {
            videoElement.current.srcObject = (_d = (_c = remoteVideoStreams.openedScreenStream) === null || _c === void 0 ? void 0 : _c.stream) !== null && _d !== void 0 ? _d : null;
        }
    }, [remoteVideoStreams.openedScreenStream]);
    const closeStream = () => {
        remoteVideoStreams.setOpenedScreenStream(undefined);
    };
    return (React.createElement("div", { className: "shared-screen-surface", style: { visibility: remoteVideoStreams.openedScreenStream ? "visible" : "hidden" }, ref: videoContainer },
        React.createElement(ModalBackdrop, { dark: true, doNotShake: true, containerOnly: true },
            React.createElement("div", { className: "shared-screen-surface-controls" },
                React.createElement("span", null,
                    t("sessionview:screenshare-surface-title-prefix", "Screen shared by: "),
                    React.createElement("b", null, sharingUserName !== null && sharingUserName !== void 0 ? sharingUserName : "unknown")),
                React.createElement("div", { className: "shared-screen-surface-spacer" }),
                allUserStreams.length > 1 && (React.createElement(React.Fragment, null,
                    React.createElement("button", { className: "icon-button-small", onClick: selectPreviousStream, "data-tooltip": t("sessionview:screenshare-surface-button-prev-stream-tooltip", "Previous stream") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "angle-left"] })),
                    React.createElement("span", { className: "shared-screen-surface-stream-counter" }, ((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.streamType) === "camera"
                        ? t("sessionview:screenshare-surface-stream-type-camera", "Camera")
                        : t("sessionview:screenshare-surface-stream-type-screen", "Screen {{index}}", {
                            index: userScreenStreams.findIndex((s) => { var _a; return s.stream === ((_a = remoteVideoStreams.openedScreenStream) === null || _a === void 0 ? void 0 : _a.stream); }) + 1
                        })),
                    React.createElement("button", { className: "icon-button-small", onClick: selectNextStream, "data-tooltip": t("sessionview:screenshare-surface-button-next-stream-tooltip", "Next stream") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "angle-right"] })))),
                React.createElement("button", { className: "icon-button-small", "data-tooltip": fullscreen
                        ? t("sessionview:screenshare-surface-button-close-fullscreen-tooltip", "Leave fullscreen mode")
                        : t("sessionview:screenshare-surface-button-enter-fullscreen-tooltip", "View in fullscreen mode") },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", fullscreen ? "compress" : "expand"], onClick: () => {
                            setFullscreen((prev) => !prev);
                        } })),
                React.createElement("button", { className: "icon-button-small", "data-tooltip": t("sessionview:sceenshare-surface-button-close-screenshare-tooltip", "Close this shared screen") },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "times"], onClick: closeStream }))),
            React.createElement("video", { id: "shared-screen-video", autoPlay: true, playsInline: true, muted: true, ref: videoElement }))));
}
